/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WeaknessMappingDto } from './WeaknessMappingDto';
import {
    WeaknessMappingDtoFromJSON,
    WeaknessMappingDtoFromJSONTyped,
    WeaknessMappingDtoToJSON,
    WeaknessMappingDtoToJSONTyped,
} from './WeaknessMappingDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface WeaknessMappingStalenessResponse
 */
export interface WeaknessMappingStalenessResponse {
    /**
     * 
     * @type {number}
     * @memberof WeaknessMappingStalenessResponse
     */
    staleDays?: number;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessMappingStalenessResponse
     */
    cutoff?: Date;
    /**
     * 
     * @type {number}
     * @memberof WeaknessMappingStalenessResponse
     */
    staleCount?: number;
    /**
     * 
     * @type {Array<WeaknessMappingDto>}
     * @memberof WeaknessMappingStalenessResponse
     */
    staleMappings?: Array<WeaknessMappingDto>;
    /**
     * 
     * @type {string}
     * @memberof WeaknessMappingStalenessResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof WeaknessMappingStalenessResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof WeaknessMappingStalenessResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof WeaknessMappingStalenessResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the WeaknessMappingStalenessResponse interface.
 */
export function instanceOfWeaknessMappingStalenessResponse(value: object): value is WeaknessMappingStalenessResponse {
    return true;
}

export function WeaknessMappingStalenessResponseFromJSON(json: any): WeaknessMappingStalenessResponse {
    return WeaknessMappingStalenessResponseFromJSONTyped(json, false);
}

export function WeaknessMappingStalenessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeaknessMappingStalenessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'staleDays': json['staleDays'] == null ? undefined : json['staleDays'],
        'cutoff': json['cutoff'] == null ? undefined : (new Date(json['cutoff'])),
        'staleCount': json['staleCount'] == null ? undefined : json['staleCount'],
        'staleMappings': json['staleMappings'] == null ? undefined : ((json['staleMappings'] as Array<any>).map(WeaknessMappingDtoFromJSON)),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function WeaknessMappingStalenessResponseToJSON(json: any): WeaknessMappingStalenessResponse {
    return WeaknessMappingStalenessResponseToJSONTyped(json, false);
}

export function WeaknessMappingStalenessResponseToJSONTyped(value?: WeaknessMappingStalenessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'staleDays': value['staleDays'],
        'cutoff': value['cutoff'] == null ? undefined : ((value['cutoff']).toISOString()),
        'staleCount': value['staleCount'],
        'staleMappings': value['staleMappings'] == null ? undefined : ((value['staleMappings'] as Array<any>).map(WeaknessMappingDtoToJSON)),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

